// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var _obj;
export var yellow = (_obj = {}, _define_property(_obj, 50, '#FFF9E5'), _define_property(_obj, 100, '#FFF4CC'), _define_property(_obj, 200, '#FFE999'), _define_property(_obj, 300, '#FFDE66'), _define_property(_obj, 400, '#FFD333'), _define_property(_obj, 500, '#FFCA0A'), _define_property(_obj, 600, '#D6A800'), _define_property(_obj, 700, '#A88400'), _define_property(_obj, 800, '#806400'), _define_property(_obj, 900, '#614C00'), _define_property(_obj, 950, '#292000'), _obj);

//# sourceMappingURL=yellow.js.map